export enum TicketSource {
  System = 'system',
  SuperAdmin = 'superadmin'
}
